var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dashboard-list"},_vm._l((_vm.list),function(item){return (item.show)?_c('link-item',{key:item.id,attrs:{"item":item}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }